import styled from "styled-components";

export const ContainerSidebar = styled.div`
  width: 314px;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 18px 24px;
  min-width: 314px;
  display: flex;
  align-items: center;
  @media (max-width: 1024px) {
      display: none;
  }
`;
